<template>
  <Error :code=code :message=message>
    <template slot="actions">
      <v-btn color="secondary" class="black--text" @click="home">
        <v-icon left>mdi-home</v-icon> Home
      </v-btn>
    </template>
    <p class="subheading font-weight-regular">
      You can't access this page or your session expired.
    </p>
  </Error>
</template>

<script>
import Error from './Error'

export default {
  name: 'Error401',
  components: {
    Error
  },

  data: () => ({
    code: 401,
    message: 'Unhautorized!'
  }),

  methods: {
    back() {
      this.$router.back();
    },
    home() {
      this.$router.push({name: 'index'});
    }
  },
}
</script>